// Redux
import { useSelector } from "react-redux";
import { selectCurrentCommunity } from "state/communities/communitiesSlice";
import { selectAllMembers, useGetMembersByCommunityIdQuery } from "state/members/membersApiSlice";
import { selectAllMeters, useGetMetersByCommunityIdQuery } from "state/meters/metersApiSlice";
import {
  selectAllResources,
  useGetResourcesByCommunityIdQuery,
} from "state/resources/resourcesApiSlice";

export function useGetCommunity() {
  return useSelector(selectCurrentCommunity);
}

export function useGetMembers(excludeDeleted) {
  const community = useSelector(selectCurrentCommunity);
  const { members } = useGetMembersByCommunityIdQuery(
    { communityId: community.id, excludeDeleted },
    {
      selectFromResult: ({ data }) => ({ members: data && selectAllMembers(data) }),
    }
  );

  return members;
}

export function useGetResources(excludeDeleted) {
  const community = useSelector(selectCurrentCommunity);

  const { resources } = useGetResourcesByCommunityIdQuery(
    { communityId: community.id, excludeDeleted },
    {
      selectFromResult: ({ data }) => ({ resources: data && selectAllResources(data) }),
    }
  );

  return resources;
}

export function useGetMeters(excludeDeleted) {
  const community = useSelector(selectCurrentCommunity);
  const { meters } = useGetMetersByCommunityIdQuery(
    { communityId: community.id, excludeDeleted },
    {
      selectFromResult: ({ data }) => ({ meters: data && selectAllMeters(data) }),
    }
  );

  return meters;
}

export const fetchDataHelper = (
  queryFunction,
  communityId,
  timeParams,
  additionalParams = {},
  refetchOnFocus = true,
  refetchOnMountOrArgChange = true,
  pollingInterval = 30000
) => {
  if (!communityId || !timeParams?.startDate || !timeParams?.endDate) {
    throw new Error("Community and Time Params must be provided");
  }

  return queryFunction(
    {
      communityId,
      startDate: timeParams.startDate,
      endDate: timeParams.endDate,
      ...additionalParams,
    },
    {
      refetchOnFocus,
      refetchOnMountOrArgChange,
      pollingInterval,
    }
  );
};

export default { useGetMembers, useGetResources, useGetMeters };
